export default __webpack_public_path__ + "cabd6ef3b2e3edff8ea6ea3179839dd5.png";